import { takeLatest, put } from 'redux-saga/effects';

import { actions as providerAuthentications } from './provider-authentications';
import { actions as connectedDevices } from './connected-devices';
import { consts as removeAccountConst } from './remove-account';

function* handleRemoveAccountWorker() {
  yield put(providerAuthentications.send());
  yield put(connectedDevices.send());
}

export function* manageDeviceAccountSaga() {
  yield takeLatest([removeAccountConst.SUCCEED], handleRemoveAccountWorker);
}



// WEBPACK FOOTER //
// ./src/redux/profiles/patientHealthboard/manage-device-account-saga.js